import { useLayoutEffect } from 'react';
import AOS from 'aos';

export function useAOS() {
    useLayoutEffect(() => {
        AOS.init({
            duration: 1000,
            easing: 'ease-in-out',
            once: true,
            mirror: false,
        });
    }, []);
}
